import { render, staticRenderFns } from "./ModalPostDetail.vue?vue&type=template&id=3559e794&"
import script from "./ModalPostDetail.vue?vue&type=script&lang=ts&"
export * from "./ModalPostDetail.vue?vue&type=script&lang=ts&"
import style0 from "./ModalPostDetail.vue?vue&type=style&index=0&id=3559e794&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports